(() => {
  const main = document.getElementById('MainContent');
  const title = document.querySelector('.main-page-title');
  const form = document.getElementById('ContactForm');
  const titleWrap = title?.parentElement;
  const formWrap = form?.parentElement;

  if (!main || !title || !form || !titleWrap || !formWrap) {
    document.body.classList.add('ht-contact-ready');
    return;
  }

  const storageKey = 'hobbytiger.contact.textScale';
  const scales = {
    decrease: 0.8,
    reset: 1
  };

  const setScale = (value) => {
    const scale = Number(value) || 1;
    main.style.setProperty('--ht-contact-text-scale', String(scale));

    main.querySelectorAll('[data-contact-text-size]').forEach((button) => {
      const buttonScale = scales[button.getAttribute('data-contact-text-size')] || 1;
      button.setAttribute('aria-pressed', buttonScale === scale ? 'true' : 'false');
    });

    try {
      window.localStorage.setItem(storageKey, String(scale));
    } catch (error) {
      // Local storage can be unavailable in some privacy modes.
    }
  };

  const buildBreadcrumb = () => {
    const nav = document.createElement('nav');
    nav.setAttribute('aria-label', 'Breadcrumb');
    const breadcrumb = document.createElement('ol');
    breadcrumb.className = 'ht-contact__breadcrumb';
    breadcrumb.innerHTML = `
      <li>
        <a class="ht-contact__breadcrumb-home" href="/" aria-label="Home"></a>
      </li>
      <li class="ht-contact__breadcrumb-separator" aria-hidden="true">·</li>
      <li class="ht-contact__breadcrumb-current" aria-current="page">Contact</li>
    `;
    nav.appendChild(breadcrumb);
    return nav;
  };

  const buildControls = () => {
    const controls = document.createElement('div');
    controls.className = 'ht-contact__text-size';
    controls.setAttribute('aria-label', 'Contact page text size');
    controls.innerHTML = `
      <button class="ht-contact__text-size-button" type="button" data-contact-text-size="decrease" aria-label="Make Contact page text smaller">A-</button>
      <button class="ht-contact__text-size-button" type="button" data-contact-text-size="reset" aria-label="Reset Contact page text size" aria-pressed="true">A</button>
    `;
    controls.addEventListener('click', (event) => {
      const button = event.target.closest('[data-contact-text-size]');
      if (!button) return;
      setScale(scales[button.getAttribute('data-contact-text-size')] || 1);
    });
    return controls;
  };

  const addIntro = () => {
    if (titleWrap.querySelector('.ht-contact__intro')) return;

    const intro = document.createElement('p');
    intro.className = 'ht-contact__intro';
    intro.textContent = 'Need help with an order, Japanese figure, import game language support, pre-order release timing, shipping from Japan, or a product condition question? Send us a message and HobbyTiger support will help you find the right next step.';

    title.insertAdjacentElement('afterend', intro);
  };

  const updateOrderNumberField = () => {
    const orderInput = form.querySelector('#ContactForm-phone, input[name="contact[Phone number]"], input[name="contact[phone]"]');
    if (!orderInput) return;

    const label = form.querySelector(`label[for="${orderInput.id}"]`);

    orderInput.id = 'ContactForm-order-number';
    orderInput.name = 'contact[Order number]';
    orderInput.type = 'text';
    orderInput.inputMode = 'text';
    orderInput.autocomplete = 'off';
    orderInput.placeholder = 'Order number';
    orderInput.setAttribute('aria-label', 'Order number');

    if (label) {
      label.setAttribute('for', orderInput.id);
      label.textContent = 'Order number';
    }
  };

  const buildSuccessPanel = () => {
    const panel = document.createElement('section');
    panel.className = 'ht-contact__success';
    panel.id = 'ContactForm';
    panel.setAttribute('aria-labelledby', 'ht-contact-success-title');
    panel.setAttribute('aria-live', 'polite');
    panel.innerHTML = `
      <h2 id="ht-contact-success-title">Message Sent</h2>
      <p>Thank you for contacting HobbyTiger. We received your message and will reply as soon as we can.</p>
    `;
    return panel;
  };

  const buildAfterSendPanel = () => {
    const panel = document.createElement('aside');
    panel.className = 'ht-contact__after-send';
    panel.innerHTML = `
      <p>In the meantime, if you need a faster answer, the Help Desk has quick information about ordering, pre-orders, shipping, customs, cancellations, returns, and product support.</p>
      <a class="ht-contact__after-send-link" href="/pages/help-desk">Go to Help Desk</a>
    `;
    return panel;
  };

  const guardCaptchaLayout = () => {
    const isCaptchaNode = (node) => {
      if (!(node instanceof HTMLElement)) return false;

      const value = [
        node.id,
        node.className,
        node.getAttribute('name'),
        node.getAttribute('src'),
        node.getAttribute('title'),
        node.getAttribute('aria-label')
      ].join(' ').toLowerCase();

      return value.includes('captcha') || value.includes('hcaptcha') || value.includes('h-captcha');
    };

    const markCaptchaNode = (node) => {
      if (!(node instanceof HTMLElement)) return;

      const descendants = node.querySelectorAll ? Array.from(node.querySelectorAll('*')) : [];
      const nodes = [node, ...descendants];
      nodes.forEach((candidate) => {
        if (!(candidate instanceof HTMLElement)) return;

        const captchaWrapper = isCaptchaNode(candidate)
          ? candidate
          : candidate.querySelector?.('[class*="captcha" i], [id*="captcha" i], [name*="captcha" i], [src*="captcha" i], [class*="hcaptcha" i], [id*="hcaptcha" i], [name*="h-captcha" i], [src*="hcaptcha" i]');

        if (!captchaWrapper) return;

        const directChild = candidate.parentElement === form ? candidate : candidate.closest?.('#ContactForm > *');
        if (directChild instanceof HTMLElement && directChild !== form && !directChild.matches('.contact__fields, .field, .contact__button')) {
          directChild.classList.add('ht-contact__captcha-layout-guard');
        }
      });
    };

    Array.from(form.children).forEach(markCaptchaNode);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(markCaptchaNode);
      });
    });

    observer.observe(form, { childList: true, subtree: true });
  };

  const showSuccessState = () => {
    const params = new URLSearchParams(window.location.search);
    const hasPostedParam = params.get('contact_posted') === 'true';
    const successStatus = form.querySelector('.form-status:not(.form-status-list), .form-status-list.form__message');
    const hasError = form.querySelector('.form__message[role="alert"], .form-status-list[role="list"]');
    const isSuccess = hasPostedParam || (!!successStatus && !hasError);

    if (!isSuccess) return;

    main.classList.add('ht-contact-main--sent');
    form.hidden = true;
    form.setAttribute('aria-hidden', 'true');
    form.id = 'ContactForm-submitted';

    if (!formWrap.querySelector('.ht-contact__success')) {
      form.insertAdjacentElement('beforebegin', buildSuccessPanel());
    }

    if (!formWrap.querySelector('.ht-contact__after-send')) {
      form.insertAdjacentElement('afterend', buildAfterSendPanel());
    }

    window.requestAnimationFrame(() => {
      formWrap.querySelector('.ht-contact__after-send-link')?.classList.add('is-animated');
      formWrap.querySelector('.ht-contact__success')?.scrollIntoView({ block: 'start' });
    });
  };

  main.classList.add('ht-contact-main');
  titleWrap.classList.add('ht-contact-title-wrap');
  formWrap.classList.add('ht-contact-form-wrap');
  title.textContent = 'Contact';

  if (!titleWrap.querySelector('.ht-contact__breadcrumb')) {
    titleWrap.insertBefore(buildBreadcrumb(), title);
  }

  if (!titleWrap.querySelector('.ht-contact__text-size')) {
    titleWrap.insertBefore(buildControls(), titleWrap.firstElementChild);
  }

  updateOrderNumberField();
  guardCaptchaLayout();
  addIntro();
  showSuccessState();

  try {
    setScale(window.localStorage.getItem(storageKey) || '1');
  } catch (error) {
    setScale(1);
  }

  document.body.classList.add('ht-contact-ready');
})();
